import type { SupportLane } from "./types";

export const SUPPORT_LANE_CREDITS_V1: Record<SupportLane, number> = {
  // Floor when token estimate is unavailable; live turns use estimated ai.tokens × weight.
  account: 1,
  product: 1,
  support: 1,
  /** Heavy tool loops / research rounds — higher floor; still max(floor, token Credits). */
  ops: 25,
  refuse: 0,
};

export const SUPPORT_LANE_LABELS: Record<SupportLane, string> = {
  account: "Account",
  product: "Product",
  support: "Support",
  ops: "Ops",
  refuse: "Policy",
};

export function isFreeSupportLane(lane: SupportLane): boolean {
  return SUPPORT_LANE_CREDITS_V1[lane] === 0;
}
